module.exports = __webpack_public_path__ + "img/athlete.aed3c11.jpg";